import React, { useRef } from 'react';
import { motion, useScroll, useSpring } from 'framer-motion';
import { experienceData } from '../data/experience';
import styles from '../styles/Experience.module.css';

const Experience = () => {
  const containerRef = useRef(null);
  
  // Track scroll progress for the timeline line
  const { scrollYProgress } = useScroll({
    target: containerRef,
    offset: ["start center", "end center"]
  });

  const scaleY = useSpring(scrollYProgress, {
    stiffness: 100,
    damping: 30,
    restDelta: 0.001
  });

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.3,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, ease: 'easeOut' },
    },
  };

  return (
    <section className={styles.experience} id="experience" ref={containerRef}>
      <div className={styles.experience__container}>
        <motion.h2
          className={styles.experience__heading}
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          Work Experience
        </motion.h2>

        <motion.div
          className={styles.experience__timeline}
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
        >
          {/* Central Line Visual */}
          <div className={styles.experience__line_container}>
            <motion.div 
              className={styles.experience__line_progress}
              style={{ scaleY }}
            />
          </div>

          {experienceData.map((exp) => (
            <motion.div
              key={exp.id}
              className={styles.experience__entry}
              variants={itemVariants}
            >
              <div className={styles.experience__header}>
                <h3 className={styles.experience__title}>{exp.role}</h3>
                <p className={styles.experience__company}>{exp.company}</p>
                <time className={styles.experience__period}>{exp.duration}</time>
              </div>

              <ul className={styles.experience__achievements}>
                {exp.description.map((point, idx) => (
                  <li key={idx} className={styles.experience__achievement}>
                    {point}
                  </li>
                ))}
              </ul>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Experience;
